import React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import * as Common from 'common/components';

const UsersListHeader = ({ companyId = '', t = (key) => key, canAdd = false }) => {
  return (
    <Common.PageHeader title={t('users.title')}>
      {canAdd && (
        <div className="btn-group pull-right">
          <Link to={`/companies/${companyId}/users/add`} className="btn btn-info">
            {t('actions.add')}
          </Link>
        </div>
      )}
    </Common.PageHeader>
  );
};

export default translate()(UsersListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/users/components/UsersListHeader.js